import * as React from "react";
import { RichTextInput } from "ra-input-rich-text";
import {
  ArrayInput,
  AutocompleteInput,
  ReferenceInput,
  SimpleFormIterator,
  TextInput,
  TranslatableInputs,
  useLocaleState,
  useTranslate,
} from "react-admin";
import RichToolbar from "../creatorsShared/RichToolbar";
import SectionPaper from "../creatorsShared/SectionPaper";
import { formatImage } from "../creatorsShared/formatImage";
import { formatBenefitIcon } from "../creatorsShared/formatBenefitIcon";
import ImageCropInput from "../creatorsShared/imageCrop/ImageCropInput";

const MainPageCreatorBuilderForm = () => {
  const [locale] = useLocaleState();
  const translate = useTranslate();

  return (
    <div>
      <SectionPaper title={translate("preview.sections.banner")}>
        <ImageCropInput
          slot="banner"
          fullWidth
          sx={{ display: "grid", gridTemplateColumns: " 1.5fr 0fr 1fr" }}
          label={false}
          source="banner.bannerImage"
          format={formatImage}
        />
        <TranslatableInputs fullWidth defaultLocale={locale} locales={["pl"]}>
          <TextInput
            fullWidth
            source="banner.bannerTitle"
            label="banners.title"
          />
          <TextInput
            fullWidth
            source="banner.bannerSubtitle"
            label="banners.subtitle"
          />
          <ArrayInput source="banner.bannerSlogans" label="banners.slogans">
            <SimpleFormIterator fullWidth>
              <RichTextInput
                toolbar={<RichToolbar />}
                fullWidth
                source="slogan"
                label="banners.slogan"
              />
            </SimpleFormIterator>
          </ArrayInput>
        </TranslatableInputs>
      </SectionPaper>

      <SectionPaper title={translate("resources.about.name")}>
        <ImageCropInput
          slot="sectionImage"
          fullWidth
          sx={{ display: "grid", gridTemplateColumns: " 1.5fr 0fr 1fr" }}
          label={false}
          source="about.sectionImage"
          format={formatImage}
        />
        <TranslatableInputs fullWidth defaultLocale={locale} locales={["pl"]}>
          <TextInput fullWidth source="about.sectionTitle" label="about.title" />
          <TextInput
            fullWidth
            source="about.sectionSubtitle"
            label="about.subtitle"
          />
          <RichTextInput
            toolbar={<RichToolbar />}
            fullWidth
            source="about.sectionDescription"
            label="about.description"
          />
          <ArrayInput label="about.companyInfo" source="about.companyInfo">
            <SimpleFormIterator fullWidth>
              <TextInput fullWidth source="title" label="about.optionTitle" />
              <TextInput
                fullWidth
                source="description"
                label="about.optionDescription"
              />
            </SimpleFormIterator>
          </ArrayInput>
        </TranslatableInputs>
      </SectionPaper>

      <SectionPaper title={translate("resources.benefits.name")}>
        <TranslatableInputs fullWidth defaultLocale={locale} locales={["pl"]}>
          <TextInput
            fullWidth
            source="benefits.sectionTitle"
            label="benefits.title"
          />
          <TextInput
            fullWidth
            source="benefits.sectionSubtitle"
            label="benefits.subtitle"
          />
          <TextInput
            fullWidth
            source="benefits.sectionDescription"
            label="benefits.description"
          />
          <ArrayInput source="benefits.benefits" label="benefits.benefits">
            <SimpleFormIterator fullWidth>
              <ImageCropInput
                slot="icon"
                fullWidth
                sx={{ display: "grid", gridTemplateColumns: " 1.5fr 0fr 1fr" }}
                label={false}
                source="icon"
                format={formatBenefitIcon}
              />
              <TextInput
                fullWidth
                source="title"
                label="benefits.benefitTitle"
              />
              <TextInput
                fullWidth
                source="description"
                label="benefits.benefitDescription"
              />
            </SimpleFormIterator>
          </ArrayInput>
        </TranslatableInputs>
      </SectionPaper>

      <SectionPaper title={translate("resources.popular.name")}>
        <TranslatableInputs fullWidth defaultLocale={locale} locales={["pl"]}>
          <TextInput
            fullWidth
            source="popular.sectionTitle"
            label="popular.title"
          />
          <TextInput
            fullWidth
            source="popular.sectionSubtitle"
            label="popular.subtitle"
          />
          <RichTextInput
            toolbar={<RichToolbar />}
            fullWidth
            source="popular.sectionDescription"
            label="popular.description"
          />
          <ArrayInput source="popular.services" label="popular.services">
            <SimpleFormIterator fullWidth>
              <TextInput fullWidth source="title" label="popular.problem" />
              <ReferenceInput source="service" reference="services">
                <AutocompleteInput
                  fullWidth
                  label="popular.service"
                  optionText={`serviceName.${locale}`}
                />
              </ReferenceInput>
            </SimpleFormIterator>
          </ArrayInput>
        </TranslatableInputs>
      </SectionPaper>
    </div>
  );
};

export default MainPageCreatorBuilderForm;
